import { BffClient } from '~/clients/BffClient'

export const useBffClient = (): BffClient => {
  return new BffClient()
}
